/* eslint-disable max-len */
import React, { useEffect, useState } from 'react'
import CustomeDatePicker from '../../../../../../components/DatePicker'
import Input from '../../../../../../components/InputBox'
import DropDownComponent from '../../../../Directory/Components/AddStudentComponents/DropDownComponent'
import { GetBranchId } from '../../../../../../CommonMethods/GetBranchId'
import { dataService } from '../../../../../../services/data.services'
import { handleKeyDownForNumber } from '../../../../../../CommonMethods/handleKeyDownForNumber'
import TextArea from '../../../../../../components/TextArea'

export default function StudentData({
    submitSelected,
    setsubmitSelected,
    state,
    setToastErrorMessage,
    handleFieldError,
    setdateError,
    handleSelectedDate,
    handleDropDownValue,
    handleDropdown,
    handleInput,
    descriptionCount,
    appliedError,
    disabledFutureDate,
    setState,
    receiptTypes
}) {
    const [ledgerList, setLedgerList] = useState([])
    /**
     * The function `getLedger` retrieves a list of ledger names from an API based on a specific branch
     * ID and search value.
     */
    const clearIfValueIsZero = () => (e) => {
        if (Number(e.target.value) === 0) {
            e.target.value='';
            handleInput(e);
        }
    };

    const setZeroIfEmpty = () => (e) => {
        let value = e.target.value;
        if (value.trim() === '') {
            value = '0.00';
        } else {
            value = parseFloat(value).toFixed(2);
        }
        e.target.value=value;
        handleInput(e);
    };

    const getLedger = async() => {
        const branch_id = await GetBranchId()
        let searchValue = encodeURIComponent("Assets > Cash & Bank > ")
        setState((prv) => ({
            ...prv,
            ledger_id: '',
            ledger_name: ''
        }));
        setLedgerList([]);
        searchValue =
            state.collection_type === 'RTE'
                ? encodeURIComponent('Assets > Current Assets > Sundry Debtors > RTE >')
                : (state.collection_type === 'Scholarship'
                    ? encodeURIComponent('Assets > Current Assets > Sundry Debtors > Scholarship >')
                    : (state.collection_type === 'Write-off'
                        ? encodeURIComponent('Expenses > Indirect Expenses > Write-off >')
                        : (state.collection_type === 'Discount'
                            ? encodeURIComponent('Expenses > Indirect Expenses > Discount >')
                            : searchValue)));
        const res= await dataService.GetAPI(`groups-and-ledgers?branch_id=${branch_id}&type=ledger&search=${searchValue}&status=active&filter=true&role=collect-fee`);
        setLedgerList(res?.data?.data?.data);
    }
    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, it
    is used to fetch the list of ledger names from an API and update the `ledgerList` state
    variable. */
    useEffect(() => {
        getLedger()
    }, [])

    useEffect(() => {
        if (receiptTypes && receiptTypes.length === 1 && receiptTypes[0] === 'Receipt') {
            setState((prev) => ({
                ...prev,
                collection_type: 'Receipt'
            }));
        }
        if (state.collection_type) {
            getLedger();
        }
        
    }, [state.collection_type]);


    return (
        <div className='pb-3 left-0 bg-white right-0 z-30'>
            <div className='w-[812px] 2xl:w-[60%] mx-auto'>
                <div className='border border-[#D0D5DD] p-3 rounded'>
                    <div className='flex -mx-10'>
                        <div className='w-full px-10'>
                            <div className='flex relative'>
                                <div className=' flex items-center mb-4 w-full relative'>
                                    <label for="student_id" class="text-f7 font-normal text-[#031624] min-w-[150px] inline-flex">Student Name</label>
                                    <div class="relative" >
                                        <p
                                            id='student_name'
                                            className={`text-[#000] rounded block w-full pr-[34px] py-1.5 placeholder:text-f7 placeholder:text-[#818E98] placeholder:font-normal text-f7 font-semibold outline-none error_border`}
                                        >
                                            {state?.student_name} [{state.student_id}], {state?.class_name} {state?.section_name}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex -mx-10'>
                        <div className='w-[50%] px-8 pl-10'>
                            <div className='flex'>
                                <div className='relative flex items-center mb-4 w-full'>
                                    <label htmlFor="received_amount" class={`text-f7 font-normal text-[#031624] min-w-[150px] inline-flex`}>Collection Amount<span class="req-fld-astrk">*</span></label>
                                    <div class="relative w-full">
                                        <input
                                            type="text"
                                            // state={state}
                                            id="received_amount"
                                            onChange={handleInput}
                                            value={state.received_amount}
                                            autoComplete='off'
                                            // onInput={(e) => {
                                            //     e.target.value = e.target.value.replace(/[^\d-]/g, ''); // Keep digits and minus sign
                                            // }}                                        // submitSelected={submitSelected}
                                            // setsubmitSelected={setsubmitSelected}
                                            text={"Enter Collection Amount"}
                                            placeholder={"0.00"}
                                            onKeyDown={handleKeyDownForNumber}
                                            onFocus={clearIfValueIsZero('received_amount')}
                                            onBlur={setZeroIfEmpty('received_amount')}
                                            className={`${((submitSelected || appliedError)&& (state.received_amount === "" || state.received_amount === "0") || appliedError) ? "redBorder" : ""} w-full inpt-fld error_border`}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='flex'>
                                <div className='relative flex items-center mb-4 w-full'>
                                    <label for="date_of_birth" class={`text-f7 font-normal text-[#031624] min-w-[150px] inline-flex`}>Collection Date<span class="req-fld-astrk">*</span></label>
                                    <div class="relative w-full">
                                        <CustomeDatePicker
                                            setToastErrorMessage={setToastErrorMessage}
                                            setsubmitSelected={setsubmitSelected}
                                            id='received_date'
                                            showErrorBorder={((submitSelected && (state.received_date === "" || state.received_date === undefined)) || handleFieldError === "received_date")}
                                            isMandatoryField={true}
                                            format="MMM DD, YYYY"
                                            state={state}
                                            placeholder="Select Date"
                                            imageClass={true}
                                            setdateError={setdateError}
                                            handleSelect={handleSelectedDate}
                                            disabledFutureDate={disabledFutureDate}
                                        // disabledDate={state.po_number === ""}
                                        // disabledFutureDate={!JSON.parse(localStorage.getItem('FY_details')).start_date}
                                        //onBlur={onBlur}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='flex'>
                                <div className='flex items-center w-full'>
                                    <label
                                        htmlFor='item_code'
                                        className='text-f7 font-normal text-[#031624] min-w-[150px] inline-flex'
                                    >
                                        Financial Year
                                    </label>
                                    <input
                                        type="text"
                                        value={`${JSON.parse(localStorage.getItem('FY_details')).name} (${JSON.parse(localStorage.getItem('FY_details')).status.charAt(0).toUpperCase() + JSON.parse(localStorage.getItem('FY_details')).status.slice(1)})`}
                                        id="financial_year"
                                        maxLength={30}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        text={"Enter Financial Year"}
                                        placeholder="Enter Financial Year"
                                        disabled={true}
                                        className={`w-full inpt-fld error_border`}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='w-[50%] px-10'>
                            <div className='flex'>
                                <div className='relative flex items-center mb-4 w-full'>
                                    <label htmlFor="" class="text-f7 font-normal text-[#031624] min-w-[145px] inline-flex">Collection Type<span class="req-fld-astrk">*</span></label>
                                    <DropDownComponent
                                        divClassName={'relative w-full'} 
                                        isMandatoryField={true}
                                        options={receiptTypes}
                                        dropdownkey={"collection_type"}
                                        studentDetails={state}
                                        submitSelected={submitSelected}
                                        handleDropDownValue={handleDropDownValue}
                                        handleDropdown={handleDropdown}
                                        placeholder={"Select Type"}
                                        selectedvalue={state.collection_type}
                                        title={state.collection_type} 
                                        showErrorBorder={submitSelected && (state.collection_type === "" || state.collection_type === undefined)}
                                    />     
                                </div>
                            </div>
                            <div className='flex'>
                                <div className='relative flex items-center mb-4 w-full'>
                                    <label htmlFor="" class="text-f7 font-normal text-[#031624] min-w-[145px] inline-flex">Ledger Name<span class="req-fld-astrk">*</span></label>
                                    <DropDownComponent
                                        divClassName={'relative w-full'} 
                                        showErrorBorder={submitSelected && (state.ledger_name === "" || state.ledger_name === undefined)} 
                                        isMandatoryField={true}
                                        options={ledgerList}
                                        dropdownkey={"ledger_name"}
                                        studentDetails={state}
                                        submitSelected={submitSelected}
                                        handleDropDownValue={handleDropDownValue}
                                        // showDropdown={showDropdown}
                                        handleDropdown={handleDropdown}
                                        placeholder={"Select Ledger"}
                                        selectedvalue={state.ledger_name!=undefined?state.ledger_name.substring(state.ledger_name.lastIndexOf('>') + 1).trim():state.ledger_name}
                                        title={state.ledger_name}
                                        obj={"parent_group_name_composite_key"}
                                        
                                        isLedgerSelect={true}
                                    />     
                                </div>
                            </div>
                            <div className='flex'>
                                <div className='flex items-center mb-4 w-full'>
                                    <label
                                        htmlFor='uom'
                                        className='text-f7 font-normal text-[#031624] min-w-[150px] inline-flex'
                                    >
                                        Reference Number
                                    </label>
                                    <Input 
                                        type="text"
                                        state={state}
                                        id="reference_number"
                                        maxLength={30}
                                        handleInput={handleInput}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        text={"Enter Reference Number"}
                                        placeholder={"Enter Reference Number"}
                                    />
                                </div>
                            </div>
                            <div className="flex">
                                <div className='flex w-full'>
                                    <label
                                        htmlFor='note'
                                        className='text-f7 font-normal text-[#031624] min-w-[150px] inline-flex'
                                    >
                                        Notes
                                    </label>
                                    <div class="w-[203px]">
                                        <TextArea
                                            type="text"
                                            state={state}
                                            wordsLength={descriptionCount > 100}
                                            handleInput={handleInput}
                                            setsubmitSelected={setsubmitSelected}
                                            id="note"
                                            placeholder="Enter Notes"
                                        >
                                        </TextArea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
